// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609010034/js/" + chunkId + "." + {"44":"a52feb68","225":"945a01b4","481":"583e9c6a","486":"1bc56748","770":"8c015070"}[chunkId] + ".0.6257858811850057.chunk.js";
};